import { render, staticRenderFns } from "./perishable-cargo.vue?vue&type=template&id=83cfe812&"
import script from "./perishable-cargo.vue?vue&type=script&lang=js&"
export * from "./perishable-cargo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports